import { Box, Button, Collapse, IconButton, Typography, useTheme } from '@mui/material'
import React, { useMemo } from 'react'
import Latex from 'react-latex-next'
import { Icons, latexDelimiters } from '../../utils/utilities'



const answerdStyles = {
    position: 'relative',
    background: 'green !important',
    color: 'white',
}

const notAnsweredStyles = {
    position: 'relative',
    background: '#888',
    color: 'white',
}

export default function QuestionList ( { questions, selectQuestion, currentQuestionIndex, submissions, showQuestions, toggleQuestionsList } ) {

    const { palette, border } = useTheme()

    const questionNbrStyles = useMemo( () => (
        {
            display: 'flex',
            padding: '2px',
            width: '20px',
            height: '20px',
            minWidth: '20px',
            minHeight: '20px',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '50%',
            background: palette.contentBg,
            fontSize: '12px',
            fontWeight: 'bold'
        }
    ), [] )

    const isAnswered = ( id ) => {
        for ( let i = 0; i < submissions.length; i++ ) {
            if ( submissions[i].question_id === id ) {
                return true
            }
        }
        return false
    }

    return (
        <Box bgcolor={!showQuestions && palette.contentBg} className="slim-custom-scrollbar" sx={{ zIndex: "10", position: "relative", overflow: "auto" }} width={showQuestions ? "auto" : "40px"}>
            {!showQuestions && <Box paddingTop="2px" >
                <Box margin="2px" color={palette.text.secondary} borderRadius="5px" display="flex" flexDirection="column" padding="10px" alignItems="center" gap="10px" sx={{ cursor: "pointer", ":hover": { background: palette.greyedOut } }} onClick={toggleQuestionsList}>
                    <Typography sx={{ writingMode: "vertical-rl", textOrientation: "mixed", }} variant='subtitle2' color='textSecondary'>Questions</Typography>
                    {Icons.default.ChevronRightIcon}
                </Box>

            </Box>}
            {showQuestions && <Collapse
                in={showQuestions}
                collapsedSize={40}
                orientation="horizontal"
                className="custom-scrollbar"
                sx={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    overflowY: "auto",
                    overflowX: "hidden", // ✅ prevent horizontal scroll
                }}
            >
                <Box display="flex" alignItems="center" justifyContent="space-between" gap="10px" width="100%" padding="10px">
                    <Typography
                        variant='subtitle2'
                        component="h4"
                        display={{ md: "block", xs: "none" }}
                        position="sticky"
                        top="0"
                        sx={{ zIndex: 10 }}
                    >
                        Questions
                    </Typography>
                    <IconButton onClick={toggleQuestionsList} size='small'>
                        {Icons.default.ChevronLeftIcon}
                    </IconButton>
                </Box>
                <Box
                    flexGrow={1}
                    display="flex"
                    position="relative"
                    flexDirection="column"
                    overflow="auto"
                    gap="5px"
                    sx={{
                        overflowX: "hiddem"
                    }}
                    maxWidth={{
                        lg: showQuestions ? "300px" : "0px",
                        md: showQuestions ? "250px" : "0px",
                        sm: showQuestions ? "50px" : "0px",
                        xs: showQuestions ? "50px" : "0px",
                    }}
                >
                    {questions.map( ( question, index ) => (
                        <Box
                            key={question.question.question_id}
                            display="flex"
                            alignItems={{ md: "flex-start", xs: "center" }}
                            bgcolor={palette.contentBg}
                            border={
                                `2px solid ${currentQuestionIndex === index
                                    ? palette.primary.light
                                    : palette.contentBg}`
                            }
                            color={palette.common.font}
                            padding={{ md: "10px", xs: "10px" }}
                            margin="0 5px"
                            borderRadius="5px"
                            fontSize="12px"
                            sx={{
                                cursor: "pointer",
                                justifyContent: { md: "flex-start", xs: "center" },
                                "&:hover": {
                                    background:
                                        currentQuestionIndex === index
                                            ? "none"
                                            : palette.rowHover,
                                    color: palette.common.font
                                },
                                "@media(max-width:350px)": { padding: "2px !important" },
                            }}
                            onClick={() => selectQuestion( question.question.question_id )}
                        >
                            <Box
                                sx={
                                    isAnswered( question.question.question_id )
                                        ? { ...questionNbrStyles, ...answerdStyles }
                                        : { ...questionNbrStyles, ...notAnsweredStyles }
                                }
                            >
                                {index + 1}
                            </Box>
                            <Box
                                marginLeft="10px"
                                flexGrow={1}
                                sx={{ display: { md: "block", xs: "none" }, minWidth: 0 }} // ✅ needed for text ellipsis
                            >
                                <Typography
                                    variant="subtitle1"
                                    component="div"
                                    fontSize="12px"
                                    color={palette.common.font}
                                    fontWeight="500"
                                    sx={{
                                        lineHeight: '1em',
                                        /* two-line clamp */
                                        display: '-webkit-box',
                                        WebkitLineClamp: 2,         // <- number of lines
                                        WebkitBoxOrient: 'vertical',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        // optional: preserve word-break behavior
                                        whiteSpace: 'normal',
                                        color: palette.common.font
                                    }}
                                >
                                    <Latex delimiters={latexDelimiters}>
                                        {question.question.question_text.replace( "LATEX-", "" )}
                                    </Latex>
                                </Typography>
                                {/* <Box display="flex" alignItems="center" gap="5px">
                                    <Typography color="secondary" fontSize="12px">
                                        {question.question.question_type}
                                    </Typography>
                                    <Typography color="secondary" fontSize="12px">
                                        {question.question.question_answer_selection}
                                    </Typography>
                                </Box> */}
                            </Box>
                        </Box>
                    ) )}
                </Box>
            </Collapse>}
        </Box>
    )
}
